// Country code → region bucket map (mirror of backend/data/african_countries.py).
// Used by the unified Chat page to default a user to their regional room.
export const COUNTRY_REGION = {
  // West
  NG: "West", GH: "West", BJ: "West", BF: "West", CV: "West", CI: "West",
  GM: "West", GN: "West", GW: "West", LR: "West", ML: "West", MR: "West",
  NE: "West", SN: "West", SL: "West", TG: "West",
  // East
  BI: "East", KM: "East", DJ: "East", ER: "East", ET: "East", KE: "East",
  MG: "East", MW: "East", MU: "East", MZ: "East", RW: "East", SC: "East",
  SO: "East", SS: "East", TZ: "East", UG: "East", ZM: "East", ZW: "East",
  // North
  DZ: "North", EG: "North", LY: "North", MA: "North", SD: "North",
  TN: "North", EH: "North",
  // Central
  AO: "Central", CM: "Central", CF: "Central", TD: "Central", CG: "Central",
  CD: "Central", GQ: "Central", GA: "Central", ST: "Central",
  // Southern
  BW: "Southern", SZ: "Southern", LS: "Southern", NA: "Southern", ZA: "Southern",
  // Rest of World
  ROW: "ROW",
};

export const REGION_TO_ROOM = {
  West: "region-west",
  East: "region-east",
  North: "region-north",
  Southern: "region-southern",
  Central: "region-west", // Central currently joins West Africa room (small cohort)
};

export function defaultRoomFor(country) {
  if (!country) return "global";
  const region = COUNTRY_REGION[country];
  return REGION_TO_ROOM[region] || "global";
}
